<div class="order-form d-flex flex-column h-100">
  <div class="flex-fill overflow-auto">
    <div mat-dialog-title class="d-flex pb-0">
      <h2 class="text-center flex-grow-1">Create New Order</h2>
      <button
        mat-button
        class="close-icon"
        tabindex="-1"
        (click)="onClosingOrderDialog()"
      >
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <mat-dialog-content #dialogContentScrollArea>
      <div class="container mb-2">
        <div class="row">
          <div class="col">
            <div class="bgcomp row">
              <div class="col my-3 mx-3">
                <form [formGroup]="orderForm">
                  <div class="row section">
                    <div class="col-2">
                      <h4 class="form-label mt-3">SITE</h4>
                    </div>
                    <div class="col">
                      <div class="mt-3">
                        <mat-form-field class="editor">
                          <mat-label>Select Site</mat-label>
                          <mat-select
                            formControlName="siteId"
                            id="siteId"
                            [panelWidth]="null"
                            required
                          >
                            <mat-option
                              *ngFor="let site of sites"
                              [value]="site.siteId"
                              >{{ site.siteName }}</mat-option
                            >
                          </mat-select>
                          <mat-error
                            *ngIf="
                              form.siteId.invalid &&
                              (form.siteId.dirty || form.siteId.touched)
                            "
                            class="invalid-feedback"
                          >
                            <div *ngIf="form.siteId.errors.required">
                              Please select a Site.
                            </div>
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>
                  </div>
                  <div class="row section mt-3">
                    <div class="col-2">
                      <h4 class="form-label mt-3">PATIENT</h4>
                    </div>
                    <div class="col">
                      <div class="d-flex mt-3">
                        <div>
                          <mat-form-field class="editor">
                            <mat-label>First Name</mat-label>
                            <input
                              type="text"
                              matInput
                              formControlName="patientFirstName"
                              id="patientFirstName"
                              required
                            />
                            <mat-error
                              *ngIf="
                                form.patientFirstName.invalid &&
                                (form.patientFirstName.dirty ||
                                  form.patientFirstName.touched)
                              "
                              class="invalid-feedback"
                            >
                              <div
                                *ngIf="form.patientFirstName.errors.required"
                              >
                                First Name is required.
                              </div>
                              <div
                                *ngIf="form.patientFirstName.errors.maxlength"
                              >
                                Name must be no more than 64 characters long.
                              </div>
                              <div *ngIf="form.patientFirstName.errors.pattern">
                                Invalid characters in the name.
                              </div>
                            </mat-error>
                          </mat-form-field>
                        </div>
                        <div class="ml-3">
                          <mat-form-field class="editor">
                            <mat-label>Last Name</mat-label>
                            <input
                              type="text"
                              matInput
                              formControlName="patientLastName"
                              id="patientLastName"
                              required
                            />
                            <mat-error
                              *ngIf="
                                form.patientLastName.invalid &&
                                (form.patientLastName.dirty ||
                                  form.patientLastName.touched)
                              "
                              class="invalid-feedback"
                            >
                              <div *ngIf="form.patientLastName.errors.required">
                                Last Name is required.
                              </div>
                              <div
                                *ngIf="form.patientLastName.errors.maxlength"
                              >
                                Name must be no more than 64 characters long.
                              </div>
                              <div *ngIf="form.patientLastName.errors.pattern">
                                Invalid characters in the name.
                              </div>
                            </mat-error>
                          </mat-form-field>
                        </div>
                        <div class="ml-3">
                          <mat-form-field class="editor">
                            <mat-label>MRN</mat-label>
                            <input
                              type="text"
                              matInput
                              formControlName="medicalRecordNumber"
                              id="medicalRecordNumber"
                              required
                            />
                            <mat-error
                              *ngIf="
                                form.medicalRecordNumber.invalid &&
                                (form.medicalRecordNumber.dirty ||
                                  form.medicalRecordNumber.touched)
                              "
                              class="invalid-feedback"
                            >
                              <div
                                *ngIf="form.medicalRecordNumber.errors.required"
                              >
                                MRN is required.
                              </div>
                              <div
                                *ngIf="
                                  form.medicalRecordNumber.errors.maxlength
                                "
                              >
                                MRN must be no more than 64 characters long.
                              </div>
                              <div
                                *ngIf="form.medicalRecordNumber.errors.pattern"
                              >
                                Invalid characters in the field.
                              </div>
                            </mat-error>
                          </mat-form-field>
                        </div>
                        <div class="ml-3">
                          <mat-form-field class="editor" floatLabel="auto">
                            <mat-label>DOB</mat-label>
                            <input
                              matInput
                              [matDatepicker]="dobPicker"
                              [matDatepickerFilter]="dateFilter"
                              placeholder="dd/mm/yyyy"
                              formControlName="patientBirthDate"
                              id="patientBirthDate"
                            />
                            <mat-datepicker-toggle
                              matSuffix
                              [for]="dobPicker"
                            ></mat-datepicker-toggle>
                            <mat-datepicker #dobPicker></mat-datepicker>
                            <mat-error
                              *ngIf="
                                form.patientBirthDate.invalid &&
                                (form.patientBirthDate.dirty ||
                                  form.patientBirthDate.touched)
                              "
                              class="invalid-feedback"
                            >
                              <div
                                *ngIf="
                                  form.patientBirthDate.errors
                                    .matDatepickerFilter
                                "
                              >
                                Future date is not allowed.
                              </div>
                              <div
                                *ngIf="
                                  form.patientBirthDate.errors
                                    .matDatepickerParse
                                "
                              >
                                Invalid date format
                              </div>
                            </mat-error>
                          </mat-form-field>
                        </div>
                      </div>
                      <div class="d-flex mt-3">
                        <div>
                          <mat-form-field class="editor">
                            <mat-label>Patient Location</mat-label>
                            <input
                              type="text"
                              matInput
                              formControlName="patientLocation"
                              id="patientLocation"
                              required
                              [matAutocomplete]="autoPatientLocation"
                            />
                            <mat-autocomplete
                              #autoPatientLocation="matAutocomplete"
                            >
                              <mat-option
                                *ngFor="
                                  let option of filteredPatientLocation | async
                                "
                                [value]="option"
                              >
                                {{ option }}
                              </mat-option>
                            </mat-autocomplete>
                            <mat-error
                              *ngIf="
                                form.patientLocation.invalid &&
                                (form.patientLocation.dirty ||
                                  form.patientLocation.touched)
                              "
                              class="invalid-feedback"
                            >
                              <div *ngIf="form.patientLocation.errors.required">
                                Patient Location is required.
                              </div>
                              <div
                                *ngIf="form.patientLocation.errors.maxlength"
                              >
                                Patient Location must be no more than 64
                                characters long.
                              </div>
                              <div *ngIf="form.patientLocation.errors.pattern">
                                Invalid characters in Patient Location.
                              </div>
                            </mat-error>
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row section mt-3">
                    <div class="col-2">
                      <h4 class="form-label mt-3">ORDER</h4>
                    </div>
                    <div class="col">
                      <div class="d-flex flex-wrap mt-3">
                        <div class="w-100 pb-2">Select Urgency</div>
                        <mat-radio-group
                          class=""
                          formControlName="urgency"
                          aria-label="Select Urgency"
                        >
                          <mat-radio-button
                            class="editor ml-3"
                            *ngFor="let urgencyItem of urgencyItems"
                            [value]="urgencyItem.value"
                            >{{ urgencyItem.displayName }}</mat-radio-button
                          >
                        </mat-radio-group>
                      </div>
                      <mat-error
                        *ngIf="
                          form.urgency.invalid &&
                          (form.urgency.dirty || form.urgency.touched)
                        "
                        class="invalid-feedback"
                      >
                        <div *ngIf="form.urgency.errors.required">
                          Please select an Urgency.
                        </div>
                      </mat-error>
                      <div class="d-flex flex-wrap mt-3">
                        <div class="w-100 pb-2">
                          Please select from the dropdown below.
                        </div>
                        <mat-form-field class="editor">
                          <mat-label>Please select</mat-label>
                          <mat-select
                            formControlName="traumaStrokeSelection"
                            id="traumaStrokeSelection"
                            panelClass="no-first-option-highlight-panel"
                            required
                          >
                            <mat-option [disabled]="true"
                              >Please select</mat-option
                            >
                            <ng-container
                              *ngFor="
                                let urgencyOption of urgencyDropdownOptions
                                  | async
                              "
                            >
                              <mat-option
                                *ngIf="
                                  !urgencyOption.subValues;
                                  else optionGroup
                                "
                                [value]="urgencyOption.value"
                              >
                                {{ urgencyOption.label }}
                              </mat-option>
                              <ng-template #optionGroup>
                                <mat-optgroup [label]="urgencyOption.label">
                                  <mat-option
                                    *ngFor="
                                      let subOption of urgencyOption.subValues
                                    "
                                    [value]="subOption.value"
                                    ><ng-container
                                      *ngIf="!form.traumaStrokeSelection.value"
                                      >•
                                    </ng-container>
                                    {{ subOption.label }}
                                  </mat-option>
                                </mat-optgroup>
                              </ng-template>
                            </ng-container>
                          </mat-select>
                          <mat-error
                            *ngIf="
                              form.traumaStrokeSelection.invalid &&
                              (form.traumaStrokeSelection.dirty ||
                                form.traumaStrokeSelection.touched)
                            "
                            class="invalid-feedback"
                          >
                            <div
                              *ngIf="form.traumaStrokeSelection.errors.required"
                            >
                              Please select an option from the Urgency Level
                              dropdown.
                            </div>
                          </mat-error>
                        </mat-form-field>
                      </div>
                      <div class="d-flex flex-wrap mt-3">
                        <div class="w-100 pb-2">Select Protocol</div>
                        <mat-radio-group
                          class=""
                          formControlName="protocol"
                          aria-label="Select Urgency"
                        >
                          <mat-radio-button
                            class="editor ml-3"
                            *ngFor="let protocolType of protocolTypes"
                            [value]="protocolType.value"
                            >{{ protocolType.displayName }}</mat-radio-button
                          >
                        </mat-radio-group>
                      </div>
                      <mat-error
                        *ngIf="
                          form.protocol.invalid &&
                          (form.protocol.dirty || form.protocol.touched)
                        "
                        class="invalid-feedback"
                      >
                        <div *ngIf="form.protocol.errors.required">
                          Please select a Protocol.
                        </div>
                      </mat-error>

                      <div class="mt-3">
                        <div class="">
                          <div class="everdivider"></div>
                        </div>
                      </div>
                      <div class="mt-3">
                        <div class="">
                          <app-studies
                            [studyForms]="studyForms"
                            [commonStudies]="commonStudies"
                            [modalityList]="modalityList"
                            [studiesGroups]="studiesGroups"
                          ></app-studies>
                        </div>
                      </div>
                      <div class="">
                        <div class="">
                          <div>Notes for Radiologist</div>
                          <mat-form-field class="editor-textarea-notes">
                            <textarea
                              matInput
                              cdkAutosizeMinRows="3"
                              cdkAutosizeMaxRows="3"
                              formControlName="radiographerNotes"
                              id="radiographerNotes"
                            ></textarea>
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row section mt-3">
                    <div class="col-2">
                      <h4 class="form-label mt-3">PRIORS</h4>
                    </div>
                    <div class="col">
                      <div class="mt-3">
                        <mat-checkbox
                          class="editor editor-checkbox editor-checkbox-priors"
                          formControlName="priorSent"
                          id="priorSent"
                          (change)="onPriorsAvailableChanged(form.priorSent)"
                          >Priors Available
                        </mat-checkbox>
                      </div>
                      <div class="mt-3">
                        <div class="">
                          <div class="everdivider"></div>
                        </div>
                      </div>
                      <app-priors
                        [priorForms]="priorForms"
                        [priorSent]="form.priorSent.value"
                        [modalityList]="modalityList"
                        (addPrior)="addPrior()"
                        (deletePrior)="deletePrior($event)"
                      ></app-priors>
                    </div>
                  </div>
                  <div class="row section mt-3">
                    <div class="col-2">
                      <h4 class="form-label mt-3">CONTACT DETAILS</h4>
                    </div>
                    <div class="col mb-2">
                      <div class="mt-3">
                        <div class="d-flex align-items-center mb-1">
                          <div class="everlabel">
                            <span>Your Details</span>
                          </div>
                          <div class="everlabel ml-3">
                            <span>Referring Doctor</span>
                          </div>
                          <div class="ml-3">
                            <span>Radiographer</span>
                          </div>
                          <mat-checkbox
                            class="editorsmall editor-checkbox editor-checkbox-sameas"
                            formControlName="sameAsYourDetails"
                            id="sameAsYourDetails"
                            (change)="
                              onSameAsYourDetailsChanged(form.sameAsYourDetails)
                            "
                            ><small>Same as Your Details</small></mat-checkbox
                          >
                        </div>
                      </div>
                      <div class="d-flex">
                        <div class="everborder-right">
                          <div class="mr-2">
                            <mat-form-field
                              class="editor space-for-invalid-feedback"
                            >
                              <mat-label>Name</mat-label>
                              <input
                                type="text"
                                matInput
                                formControlName="callersName"
                                id="callersName"
                                required
                              />
                              <mat-error
                                *ngIf="
                                  form.callersName.invalid &&
                                  (form.callersName.dirty ||
                                    form.callersName.touched)
                                "
                                class="invalid-feedback"
                              >
                                <div *ngIf="form.callersName.errors.required">
                                  Name is required.
                                </div>
                                <div *ngIf="form.callersName.errors.maxlength">
                                  Name must be no more than 64 characters long.
                                </div>
                                <div *ngIf="form.callersName.errors.pattern">
                                  Invalid characters in the name.
                                </div>
                              </mat-error>
                            </mat-form-field>

                            <div class="d-flex">
                              <mat-form-field class="editor-phone">
                                <mat-label>Phone</mat-label>
                                <input
                                  type="text"
                                  matInput
                                  formControlName="contactPhone"
                                  id="contactPhone"
                                  (change)="
                                    onPhoneNumberChanged(
                                      form.contactPhone,
                                      form.contactPhoneExt
                                    )
                                  "
                                  required
                                />
                                <span
                                  class="editor-phone-countrycode"
                                  matTextPrefix
                                  >{{ defaultCountryCode }}</span
                                >
                                <mat-error
                                  class="invalid-feedback"
                                  *ngIf="
                                    form.contactPhone.invalid &&
                                    (form.contactPhone.dirty ||
                                      form.contactPhone.touched)
                                  "
                                >
                                  <div
                                    *ngIf="form.contactPhone.errors.required"
                                  >
                                    Phone Number is required.
                                  </div>
                                  <div *ngIf="form.contactPhone.errors.pattern">
                                    Only digits are accepted for phone numbers.
                                    Please retry.
                                  </div>
                                  <div
                                    *ngIf="form.contactPhone.errors.maxlength"
                                  >
                                    Phone number entered is too long. Please
                                    retry.
                                  </div>
                                  <div
                                    *ngIf="
                                      form.contactPhone.errors.invalidphone
                                    "
                                  >
                                    Phone number entered is invalid. Please
                                    retry.
                                  </div>
                                </mat-error>
                              </mat-form-field>
                              <mat-form-field class="editor-phone-ext">
                                <mat-label>Ext</mat-label>
                                <input
                                  type="text"
                                  matInput
                                  formControlName="contactPhoneExt"
                                  id="contactPhoneExt"
                                  [readonly]="!form.contactPhone.value"
                                />
                              </mat-form-field>
                            </div>
                            <mat-error
                              class="invalid-feedback"
                              *ngIf="
                                form.contactPhoneExt.invalid &&
                                (form.contactPhoneExt.dirty ||
                                  form.contactPhoneExt.touched)
                              "
                            >
                              <div *ngIf="form.contactPhoneExt.errors.pattern">
                                Only digits are accepted for phone extension.
                                Please retry.
                              </div>
                              <div
                                *ngIf="form.contactPhoneExt.errors.maxlength"
                              >
                                Phone extension entered is too long. Please
                                retry.
                              </div>
                            </mat-error>
                          </div>
                        </div>
                        <div class="ml-1 everborder-right">
                          <div class="mr-2">
                            <div>
                              <mat-form-field
                                class="editor space-for-invalid-feedback"
                              >
                                <mat-label>Name</mat-label>
                                <input
                                  type="text"
                                  matInput
                                  formControlName="verbalDoctorReceivingReport"
                                  id="verbalDoctorReceivingReport"
                                  required
                                  [matAutocomplete]="autoReferringDoctor"
                                />
                                <mat-autocomplete
                                  #autoReferringDoctor="matAutocomplete"
                                  (optionSelected)="selectedDoctor($event)"
                                >
                                  <mat-option
                                    *ngFor="
                                      let option of filteredReferringDoctors
                                        | async
                                    "
                                    [value]="option"
                                  >
                                    {{ option }}
                                  </mat-option>
                                </mat-autocomplete>
                                <mat-error
                                  *ngIf="
                                    form.verbalDoctorReceivingReport.invalid &&
                                    (form.verbalDoctorReceivingReport.dirty ||
                                      form.verbalDoctorReceivingReport.touched)
                                  "
                                  class="invalid-feedback"
                                >
                                  <div
                                    *ngIf="
                                      form.verbalDoctorReceivingReport.errors
                                        .required
                                    "
                                  >
                                    Name is required.
                                  </div>
                                  <div
                                    *ngIf="
                                      form.verbalDoctorReceivingReport.errors
                                        .maxlength
                                    "
                                  >
                                    Name must be no more than 64 characters
                                    long.
                                  </div>
                                  <div
                                    *ngIf="
                                      form.verbalDoctorReceivingReport.errors
                                        .pattern
                                    "
                                  >
                                    Invalid characters in the name.
                                  </div>
                                </mat-error>
                              </mat-form-field>
                            </div>
                            <div class="d-flex">
                              <div>
                                <mat-form-field class="editor-phone">
                                  <mat-label>Phone</mat-label>
                                  <input
                                    type="text"
                                    matInput
                                    formControlName="referringDoctorPhoneNo"
                                    id="referringDoctorPhoneNo"
                                    (change)="
                                      onPhoneNumberChanged(
                                        form.referringDoctorPhoneNo,
                                        form.referringDoctorExtension
                                      )
                                    "
                                    required
                                    [matAutocomplete]="
                                      autoReferringDoctorPhoneNo
                                    "
                                  />
                                  <span
                                    class="editor-phone-countrycode"
                                    matTextPrefix
                                    >{{ referringDoctorCountryCode }}</span
                                  >
                                  <mat-autocomplete
                                    #autoReferringDoctorPhoneNo="matAutocomplete"
                                    (optionSelected)="
                                      selectReferringDoctorPhoneNo($event)
                                    "
                                  >
                                    <mat-option
                                      *ngFor="
                                        let option of filteredReferringDoctorPhoneNo
                                          | async
                                      "
                                      [value]="option"
                                    >
                                      {{ option }}
                                    </mat-option>
                                  </mat-autocomplete>
                                  <mat-error
                                    class="invalid-feedback"
                                    *ngIf="
                                      form.referringDoctorPhoneNo.invalid &&
                                      (form.referringDoctorPhoneNo.dirty ||
                                        form.referringDoctorPhoneNo.touched)
                                    "
                                  >
                                    <div
                                      *ngIf="
                                        form.referringDoctorPhoneNo.errors
                                          .required
                                      "
                                    >
                                      Phone Number is required.
                                    </div>
                                    <div
                                      *ngIf="
                                        form.referringDoctorPhoneNo.errors
                                          .pattern
                                      "
                                    >
                                      Only digits are accepted for phone
                                      numbers. Please retry.
                                    </div>
                                    <div
                                      *ngIf="
                                        form.referringDoctorPhoneNo.errors
                                          .maxlength
                                      "
                                    >
                                      Phone number entered is too long. Please
                                      retry.
                                    </div>
                                    <div
                                      *ngIf="
                                        form.referringDoctorPhoneNo.errors
                                          .invalidphone
                                      "
                                    >
                                      Phone number entered is invalid. Please
                                      retry.
                                    </div>
                                  </mat-error>
                                </mat-form-field>
                              </div>
                              <div>
                                <mat-form-field class="editor-phone-ext">
                                  <mat-label>Ext</mat-label>
                                  <input
                                    type="text"
                                    matInput
                                    formControlName="referringDoctorExtension"
                                    id="referringDoctorExtension"
                                    [readonly]="
                                      !form.referringDoctorPhoneNo.value
                                    "
                                    [matAutocomplete]="
                                      autoReferringDoctorExtension
                                    "
                                  />
                                  <mat-autocomplete
                                    #autoReferringDoctorExtension="matAutocomplete"
                                  >
                                    <mat-option
                                      *ngFor="
                                        let option of filteredReferringDoctorExtension
                                          | async
                                      "
                                      [value]="option"
                                    >
                                      {{ option }}
                                    </mat-option>
                                  </mat-autocomplete>
                                </mat-form-field>
                              </div>
                            </div>
                            <mat-error
                              class="invalid-feedback"
                              *ngIf="
                                form.referringDoctorExtension.invalid &&
                                (form.referringDoctorExtension.dirty ||
                                  form.referringDoctorExtension.touched)
                              "
                            >
                              <div
                                *ngIf="
                                  form.referringDoctorExtension.errors.pattern
                                "
                              >
                                Only digits are accepted for phone extension.
                                Please retry.
                              </div>
                              <div
                                *ngIf="
                                  form.referringDoctorExtension.errors.maxlength
                                "
                              >
                                Phone extension entered is too long. Please
                                retry.
                              </div>
                            </mat-error>
                          </div>
                        </div>
                        <div>
                          <div class="ml-1">
                            <div>
                              <mat-form-field
                                class="editor space-for-invalid-feedback"
                              >
                                <mat-label>Name</mat-label>
                                <input
                                  type="text"
                                  matInput
                                  formControlName="radiographerName"
                                  id="radiographerName"
                                  [readonly]="form.sameAsYourDetails.value"
                                />
                                <mat-error
                                  *ngIf="
                                    form.radiographerName.invalid &&
                                    (form.radiographerName.dirty ||
                                      form.radiographerName.touched)
                                  "
                                  class="invalid-feedback"
                                >
                                  <div
                                    *ngIf="
                                      form.radiographerName.errors.maxlength
                                    "
                                  >
                                    Name must be no more than 64 characters
                                    long.
                                  </div>
                                  <div
                                    *ngIf="form.radiographerName.errors.pattern"
                                  >
                                    Invalid characters in the name.
                                  </div>
                                </mat-error>
                              </mat-form-field>
                            </div>
                            <div>
                              <div class="d-flex">
                                <mat-form-field class="editor-phone">
                                  <mat-label>Phone</mat-label>
                                  <input
                                    type="text"
                                    matInput
                                    formControlName="radiographerPhone"
                                    id="radiographerPhone"
                                    (change)="
                                      onPhoneNumberChanged(
                                        form.radiographerPhone,
                                        form.radiographerPhoneExt
                                      )
                                    "
                                    [readonly]="form.sameAsYourDetails.value"
                                  />
                                  <span
                                    class="editor-phone-countrycode"
                                    matTextPrefix
                                    >{{ defaultCountryCode }}</span
                                  >
                                  <mat-error
                                    class="invalid-feedback"
                                    *ngIf="
                                      form.radiographerPhone.invalid &&
                                      (form.radiographerPhone.dirty ||
                                        form.radiographerPhone.touched)
                                    "
                                  >
                                    <div
                                      *ngIf="
                                        form.radiographerPhone.errors.pattern
                                      "
                                    >
                                      Only digits are accepted for phone
                                      numbers. Please retry.
                                    </div>
                                    <div
                                      *ngIf="
                                        form.radiographerPhone.errors.maxlength
                                      "
                                    >
                                      Phone number entered is too long. Please
                                      retry.
                                    </div>
                                    <div
                                      *ngIf="
                                        form.radiographerPhone.errors
                                          .invalidphone
                                      "
                                    >
                                      Phone number entered is invalid. Please
                                      retry.
                                    </div>
                                  </mat-error>
                                </mat-form-field>
                                <mat-form-field class="editor-phone-ext">
                                  <mat-label>Ext</mat-label>
                                  <input
                                    type="text"
                                    matInput
                                    formControlName="radiographerPhoneExt"
                                    id="radiographerPhoneExt"
                                    [readonly]="
                                      !form.radiographerPhone.value ||
                                      form.sameAsYourDetails.value
                                    "
                                  />
                                </mat-form-field>
                              </div>
                            </div>
                            <mat-error
                              class="invalid-feedback"
                              *ngIf="
                                form.radiographerPhoneExt.invalid &&
                                (form.radiographerPhoneExt.dirty ||
                                  form.radiographerPhoneExt.touched)
                              "
                            >
                              <div
                                *ngIf="form.radiographerPhoneExt.errors.pattern"
                              >
                                Only digits are accepted for phone extension.
                                Please retry.
                              </div>
                              <div
                                *ngIf="
                                  form.radiographerPhoneExt.errors.maxlength
                                "
                              >
                                Phone extension entered is too long. Please
                                retry.
                              </div>
                            </mat-error>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row mt-4 mb-n2">
                    <div class="col-2">&nbsp;</div>
                    <div class="col">
                      <mat-checkbox
                        formControlName="isToCreateAnotherOrder"
                        id="isToCreateAnotherOrder"
                        >Create another order
                      </mat-checkbox>
                    </div>
                  </div>
                  <div>
                    <div class="row mt-4 mb-3">
                      <div class="col-2">&nbsp;</div>
                      <div class="col">
                        <div>
                          <button
                            type="button"
                            [disabled]="saving"
                            class="everbtnmain"
                            (click)="submit()"
                            id="submitOrder"
                          >
                            Save
                          </button>
                          &nbsp;
                          <button
                            type="button"
                            [disabled]="saving"
                            class="everbtn"
                            (click)="reset()"
                            id="resetOrder"
                          >
                            Reset
                          </button>
                          &nbsp;
                          <mat-spinner *ngIf="saving" diameter="32"
                            >Saving...</mat-spinner
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </mat-dialog-content>
  </div>
</div>
